/* Clearly Canadian theme, PDP behavior.
   Replaces the prototype's client-side router with the small amount of
   interactivity a real Shopify PDP needs: media swap, variant selection,
   and the one-time vs subscription toggle. */
(function () {
  'use strict';

  var form = document.getElementById('ccBuy');
  var sel = document.getElementById('ccVariant');

  /* ---------- gallery ---------- */
  var main = document.getElementById('ccGalleryMain');
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ccmedia]');
    if (!t || !main) return;
    main.src = t.dataset.ccmedia;
    main.removeAttribute('srcset');
    document.querySelectorAll('[data-ccmedia]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b === t));
    });
  });

  if (!form || !sel) return;

  /* ---------- variant selection ---------- */
  var chosen = [];
  form.querySelectorAll('[data-ccopt]').forEach(function (b) {
    if (b.getAttribute('aria-pressed') === 'true') chosen[+b.dataset.ccopt] = b.dataset.ccval;
  });

  function matchVariant() {
    var want = chosen.join(' / ');
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].textContent.trim() === want) return sel.options[i];
    }
    return null;
  }

  function money(cents) {
    // Theme-level formatting. Shopify's money filter is server side, so the
    // client formats from the integer cents carried on each option.
    return '$' + (cents / 100).toFixed(2);
  }

  function planAdjusted(cents) {
    var plan = document.getElementById('ccPlan');
    if (!plan || !plan.selectedOptions.length) return cents;
    var o = plan.selectedOptions[0];
    var v = parseFloat(o.dataset.adj || '0');
    var type = o.dataset.adjtype || '';
    if (!v) return cents;
    if (type === 'percentage') return Math.round(cents * (1 - v / 100));
    if (type === 'fixed_amount') return Math.max(0, cents - v);
    if (type === 'price') return v;
    return cents;
  }

  function paint() {
    var opt = matchVariant();
    if (opt) {
      sel.value = opt.value;
      var url = new URL(window.location);
      url.searchParams.set('variant', opt.value);
      window.history.replaceState({}, '', url);
    }
    var cents = opt ? +opt.dataset.price : 0;
    var isSub = form.querySelector('[name="cc-purchase"]:checked');
    isSub = isSub && isSub.value === 'sub';

    var one = form.querySelector('[data-ccprice-one]');
    var sub = form.querySelector('[data-ccprice-sub]');
    var atc = form.querySelector('[data-ccprice-atc]');
    if (one) one.textContent = money(cents);
    if (sub) sub.textContent = money(planAdjusted(cents)) + ' / delivery';
    if (atc) atc.textContent = money(isSub ? planAdjusted(cents) : cents);

    var cad = form.querySelector('[data-cc-cadence]');
    if (cad) cad.hidden = !isSub;
    var plan = document.getElementById('ccPlan');
    if (plan) plan.disabled = !isSub;

    var btn = form.querySelector('button[name="add"]');
    if (btn) {
      var available = opt && !opt.disabled;
      btn.disabled = !available;
      btn.classList.toggle('disabled', !available);
    }
  }

  form.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ccopt]');
    if (!b || b.disabled) return;
    chosen[+b.dataset.ccopt] = b.dataset.ccval;
    form.querySelectorAll('[data-ccopt="' + b.dataset.ccopt + '"]').forEach(function (o) {
      o.setAttribute('aria-pressed', String(o === b));
    });
    paint();
  });

  form.addEventListener('change', function (e) {
    if (e.target.name === 'cc-purchase' || e.target.id === 'ccPlan') paint();
  });

  paint();
})();


/* Oct 2, Val: submitting an email form reloaded the page and jumped to the top.
   List forms try to post in the background and show their thank-you where the
   person typed. Shopify's reCAPTCHA on contact forms rejects a background post
   (400, "Missing CAPTCHA token"), so when that happens the form submits the
   normal way, remembers which form it was, and after the reload the page
   scrolls back to that form and shows the thank-you there only. Turning the
   reCAPTCHA off for contact forms (Online Store > Preferences) makes the
   background path work and the reload disappears. */
(function(){
  var forms = [].slice.call(document.querySelectorAll('form[action*="/contact"][data-ok]'));
  if(!forms.length) return;
  var KEY = 'cc_list_form';
  function okNode(f){
    var ok = document.createElement('p');
    ok.className = 'ccok'; ok.setAttribute('role','status');
    ok.innerHTML = f.getAttribute('data-ok').replace(/EARLY10/g,'<b>EARLY10</b>');
    return ok;
  }
  // After a normal submit: land on the form that was used.
  var posted = /customer_posted=true/.test(location.search);
  var remembered = null;
  try { remembered = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch(e){}
  if(posted){
    forms.forEach(function(f, i){
      var server = f.querySelectorAll('.ok, .mok, .nm-ok, .fs-fine.full');
      if(remembered !== null && String(i) !== remembered){
        [].forEach.call(server, function(n){ n.parentNode.removeChild(n); });
      } else if(!server.length){
        f.appendChild(okNode(f));
      }
      if(remembered !== null && String(i) === remembered){ f.classList.add('is-done'); }
    });
    var target = remembered !== null ? forms[+remembered] : null;
    if(target){
      try { history.replaceState(null, '', location.pathname); } catch(e){}
      setTimeout(function(){ target.scrollIntoView({block:'center', behavior:'instant' in document.documentElement.style ? 'instant' : 'auto'}); }, 60);
    }
  }
  forms.forEach(function(f, i){
    function onSubmit(ev){
      var email = f.querySelector('input[type=email]');
      if(!email || !email.value) return;
      try { sessionStorage.setItem(KEY, String(i)); } catch(e){}
      if(!window.fetch) return;
      ev.preventDefault();
      var btn = f.querySelector('button[type=submit]');
      var was = btn ? btn.textContent : '';
      if(btn){ btn.disabled = true; btn.textContent = 'One sec'; }
      var body = new FormData(f);
      fetch(f.action, {method:'POST', body:body, credentials:'same-origin', redirect:'follow'})
        .then(function(r){
          var fine = r.ok && r.url.indexOf('challenge') < 0 && /customer_posted/.test(r.url);
          if(!fine) throw new Error('fallback');
          try { sessionStorage.removeItem(KEY); } catch(e){}
          f.classList.add('is-done');
          f.appendChild(okNode(f));
        })
        .catch(function(){
          if(btn){ btn.disabled = false; btn.textContent = was; }
          f.removeEventListener('submit', onSubmit);
          HTMLFormElement.prototype.submit.call(f);
        });
    }
    f.addEventListener('submit', onSubmit);
  });
})();

/* Search dropdown: focus the field on open, close on outside click or Escape. */
(function(){
  var d = document.querySelector('header.site .hsearch'); if(!d) return;
  d.addEventListener('toggle', function(){ if(d.open){ var i=d.querySelector('input[type=search]'); if(i) setTimeout(function(){ i.focus(); }, 0); } });
  document.addEventListener('click', function(e){ if(d.open && !d.contains(e.target)) d.open = false; });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && d.open) d.open = false; });
})();
